import { AddEditIncident, IncidentMgmt } from "@/pages";
import { routes } from "../utils";

export const IncidentMgmtRoutes = () => {
  return {
    path: routes.incidentMgmt,
    children: [
      {
        path: "",
        element: <IncidentMgmt />,
      },
      {
        path: routes.add,
        element: <AddEditIncident />,
      },
      {
        path: routes.id + "/" + routes.action,
        element: <AddEditIncident />,
      },
    ],
  };
};
